/** Joins truthy class names — shared by every design-system primitive. */
export function cx(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}
